import React, { useState, useEffect } from "react";
import Translator, { __ } from "services/Translator";
import { Link, useLocation } from "react-router-dom";
import ls from "local-storage";
import SearchBox from "../elements/SearchBox";
import LanguageSwitcher from "elements/LanguageSwitcher";
import LanguageSwitcherAccordion from "elements/LanguageSwitcherAccordion";
import api from "services/api";
import { Badge } from "react-bootstrap";
import moneyFormatter from "services/moneyFormatter";

export default function LeftSide(props) {
  const location = useLocation();
  const activeMenu = location.pathname;

  const handleChatToggle = () => {
    if (typeof window.Tawk_API !== "undefined") {
      window.Tawk_API.toggle();
    } else {
      console.error("Tawk_API is not available.");
    }
  };

  const [keySports, setKeySports] = useState(0);
  const [keyCasino, setKeyCasino] = useState(0);

  //Free spin count
  const [freeSpinCount, setFreeSpinCount] = useState(0);
  const getFreeSpinCount = async (ev) => {
    var response = await api.get("/player/unused-free-spins-count");
    if (response.status === 200) {
      setFreeSpinCount(response.data);
    }
  };

  useEffect(() => {
    var interval;
    if (props.isAuthenticated) {
      getFreeSpinCount();
    }

    interval = setInterval(() => {
      if (props.isAuthenticated) {
        getFreeSpinCount();
      }
    }, 15000);
    return () => {
      try {
        clearInterval(interval);
      } catch (ex) {}
    };
  }, []);

  const [showBalanceAsFiat, setShowBalanceAsFiat] = useState(
    ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
  );

  const [fiatCurrencyToDisplay, setFiatCurrencyToDisplay] = useState(
    ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
  );

  return (
    <div className="leftside_v2">
      <div className="topSideBar">
        <div className="casino_type">
          <Link
            to="/games/all"
            onClick={() => {
              if (props.leftSidebarSlide) {
                props.setLeftSidebarSlide(false);
              }
            }}
            onMouseEnter={() => {
              setKeyCasino(keyCasino + 1);
            }}
            className="active"
          >
            <span className="icon">
              <img
                alt=""
                key={keyCasino}
                style={{ marginTop: "-6px" }}
                src={`${require("../assets/images/v2/common/casino-icon-GJ.gif").default}?${keyCasino}`}
              />
            </span>
            <span className="text">{__("Casino")}</span>
          </Link>
          <Link
            onClick={() => {
              if (props.leftSidebarSlide) {
                props.setLeftSidebarSlide(false);
              }
            }}
            onMouseEnter={() => {
              setKeySports(keySports + 1);
            }}
            to="#"
          >
            <span className="icon">
              {/* <img
                alt=""
                key={keySports}
                style={{ marginTop: "-3px" }}
                src={`${
                  require("../assets/images/v2/common/sports-icon-GJ.gif")
                    .default
                }?${keySports}`}
              /> */}
              <img
                alt="soon"
                style={{ width: "22px" }}
                src={require("../assets/images/v2/common/coming-soon.webp").default}
              />
            </span>
            <span className="text">{__("Sports")}</span>
          </Link>
        </div>
        <SearchBox {...props} />
      </div>
      <div className="bottomSideBar">
        <ul className="menus">
          {props.isAuthenticated && (
            <li>
              <Link to="/dashboard/cashier" className={activeMenu === "cashier" ? "active" : ""}>
                <span className="icon">
                  <svg width="18" height="24" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.0321 6.08499C21.0321 5.43323 20.5037 4.90491 19.852 4.90491H6.14797C5.49622 4.90491 4.9679 5.43323 4.9679 6.08499V10.8585C4.9679 11.5102 5.49622 12.0385 6.14797 12.0385H19.852C20.5037 12.0385 21.0321 11.5102 21.0321 10.8585V6.08499ZM18.6719 9.67838H7.32805V7.26506H18.6719V9.67838Z"
                      fill="white"
                    />
                    <path
                      d="M7.20296 14.0505H6.26138C5.60962 14.0505 5.0813 14.5789 5.0813 15.2306C5.0813 15.8824 5.60962 16.4107 6.26138 16.4107H7.20296C7.85472 16.4107 8.38304 15.8824 8.38304 15.2306C8.38304 14.5789 7.85472 14.0505 7.20296 14.0505Z"
                      fill="white"
                    />
                    <path
                      d="M7.20296 18.4977H6.26138C5.60962 18.4977 5.0813 19.026 5.0813 19.6778C5.0813 20.3295 5.60962 20.8578 6.26138 20.8578H7.20296C7.85472 20.8578 8.38304 20.3295 8.38304 19.6778C8.38304 19.026 7.85472 18.4977 7.20296 18.4977Z"
                      fill="white"
                    />
                    <path
                      d="M7.20296 22.9449H6.26138C5.60962 22.9449 5.0813 23.4733 5.0813 24.125C5.0813 24.7768 5.60962 25.3051 6.26138 25.3051H7.20296C7.85472 25.3051 8.38304 24.7768 8.38304 24.125C8.38304 23.4733 7.85472 22.9449 7.20296 22.9449Z"
                      fill="white"
                    />
                    <path
                      d="M13.4708 14.0505H12.5293C11.8775 14.0505 11.3492 14.5789 11.3492 15.2306C11.3492 15.8824 11.8775 16.4107 12.5293 16.4107H13.4708C14.1225 16.4107 14.6509 15.8824 14.6509 15.2306C14.6509 14.5789 14.1225 14.0505 13.4708 14.0505Z"
                      fill="white"
                    />
                    <path
                      d="M13.4708 18.4977H12.5293C11.8775 18.4977 11.3492 19.026 11.3492 19.6778C11.3492 20.3295 11.8775 20.8578 12.5293 20.8578H13.4708C14.1225 20.8578 14.6509 20.3295 14.6509 19.6778C14.6509 19.026 14.1225 18.4977 13.4708 18.4977Z"
                      fill="white"
                    />
                    <path
                      d="M13.4708 22.9449H12.5293C11.8775 22.9449 11.3492 23.4733 11.3492 24.125C11.3492 24.7768 11.8775 25.3051 12.5293 25.3051H13.4708C14.1225 25.3051 14.6509 24.7768 14.6509 24.125C14.6509 23.4733 14.1225 22.9449 13.4708 22.9449Z"
                      fill="white"
                    />
                    <path
                      d="M20.9184 15.2306C20.9184 14.5789 20.3901 14.0505 19.7384 14.0505H18.7968C18.145 14.0505 17.6167 14.5789 17.6167 15.2306C17.6167 15.8824 18.145 16.4107 18.7968 16.4107H19.7384C20.3901 16.4107 20.9184 15.8824 20.9184 15.2306Z"
                      fill="white"
                    />
                    <path
                      d="M18.0876 19.8517V24.1251C18.0876 24.7768 18.6159 25.3051 19.2677 25.3051C19.9194 25.3051 20.4477 24.7768 20.4477 24.1251V19.8517C20.4477 19.2 19.9194 18.6716 19.2677 18.6716C18.6159 18.6716 18.0876 19.2 18.0876 19.8517Z"
                      fill="white"
                    />
                    <path
                      d="M24.8083 20.8274C25.4601 20.8274 25.9884 20.2991 25.9884 19.6474V4.72031C25.9884 2.11753 23.8709 0 21.2681 0H4.73191C2.12913 0 0.0115967 2.11753 0.0115967 4.72031V25.4897C0.0115967 28.0925 2.12913 30.21 4.73191 30.21H21.2681C23.8709 30.21 25.9884 28.0925 25.9884 25.4887C25.9884 24.837 25.4601 24.3091 24.8083 24.3091C24.1566 24.3091 23.6283 24.8379 23.6283 25.4897C23.6283 26.7911 22.5695 27.8498 21.2681 27.8498H4.73191C3.43052 27.8498 2.37175 26.7911 2.37175 25.4897V4.72031C2.37175 3.41892 3.43052 2.36016 4.73191 2.36016H21.2681C22.5695 2.36016 23.6283 3.41892 23.6283 4.72031V19.6474C23.6283 20.2991 24.1566 20.8274 24.8083 20.8274Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span className="text">
                  {__("Cashier")}
                  <Badge
                    style={{
                      verticalAlign: "middle",
                      marginLeft: "5px",
                      fontSize: "10px",
                    }}
                    className="theme_bg radius_25"
                  >
                    {/* {props.userBalance.currency}
                              {props.userBalance.total_balance} */}

                    {!!props.userBalance.wallets?.length
                      ? !props.userBalance.wallets[0].balance && props.userBalance.bonus_balance
                        ? props.userBalance.currency + props.userBalance.bonus_balance
                        : showBalanceAsFiat
                        ? moneyFormatter.convertCurrencyToFiat(
                            props.userBalance.wallets[0].balance,
                            props.userBalance.wallets[0].currency,
                            fiatCurrencyToDisplay
                          )
                        : parseFloat(props.userBalance.wallets[0].balance).toFixed(6)
                      : ""}
                    {__(" ")}
                    {!!props.userBalance.wallets?.length &&
                      moneyFormatter.currencyIcon(props.userBalance.wallets[0].currency)}
                  </Badge>
                </span>
              </Link>
            </li>
          )}
          <li className={activeMenu === "/promotions" ? "active" : ""}>
            <Link
              className={activeMenu === "/promotions" ? "active" : ""}
              onClick={() => {
                if (props.leftSidebarSlide) {
                  props.setLeftSidebarSlide(false);
                }
              }}
              to="/promotions"
            >
              <span className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.442"
                  height="16.136"
                  viewBox="24 194.932 18.442 16.136"
                >
                  <path
                    d="M25.153 209.916c0 .637.515 1.152 1.152 1.152h5.763v-5.763h-6.915v4.61Zm9.22 1.152h5.763c.638 0 1.153-.515 1.153-1.152v-4.61h-6.916v5.762Zm6.916-11.526h-1.516a3.14 3.14 0 0 0 .363-1.44 3.174 3.174 0 0 0-3.17-3.17c-1.498 0-2.467.767-3.71 2.46-1.242-1.693-2.21-2.46-3.71-2.46a3.174 3.174 0 0 0-3.169 3.17c0 .522.137 1.004.364 1.44h-1.588c-.638 0-1.153.515-1.153 1.153v2.881c0 .317.26.577.576.577h17.29c.316 0 .576-.26.576-.577v-2.881c0-.638-.515-1.153-1.153-1.153Zm-11.746 0a1.44 1.44 0 1 1 0-2.881c.717 0 1.247.119 3.102 2.881h-3.102Zm7.424 0h-3.101c1.85-2.755 2.366-2.881 3.1-2.881a1.44 1.44 0 1 1 0 2.881Z"
                    fill="#b8c0da"
                    fill-rule="evenodd"
                    data-name="Icon awesome-gift"
                  />
                </svg>
              </span>
              <span className="text">{__("Promotions")}</span>
              <span className="arrow">{">"}</span>
            </Link>
          </li>

          <li className={"vipClub " + (activeMenu === "/vip" ? "active" : "")}>
            <Link
              className={activeMenu === "/vip" ? "active" : ""}
              onClick={() => {
                if (props.leftSidebarSlide) {
                  props.setLeftSidebarSlide(false);
                }
              }}
              to="/vip"
            >
              <span className="icon">
                <svg
                  fill="#fff"
                  width="20px"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 220 220"
                  xml="preserve"
                >
                  <path
                    d="M220,98.865c0-12.728-10.355-23.083-23.083-23.083s-23.083,10.355-23.083,23.083c0,5.79,2.148,11.084,5.681,15.14
	l-23.862,21.89L125.22,73.002l17.787-20.892l-32.882-38.623L77.244,52.111l16.995,19.962l-30.216,63.464l-23.527-21.544
	c3.528-4.055,5.671-9.344,5.671-15.128c0-12.728-10.355-23.083-23.083-23.083C10.355,75.782,0,86.137,0,98.865
	c0,11.794,8.895,21.545,20.328,22.913l7.073,84.735H192.6l7.073-84.735C211.105,120.41,220,110.659,220,98.865z"
                  />
                </svg>
              </span>
              <span className="text">{__("VIP Club")}</span>
              <span className="arrow">{">"}</span>
            </Link>
          </li>

          <li className={"races " + (activeMenu === "/races" ? "active" : "")}>
            <Link
              className={activeMenu === "/races" ? "active" : ""}
              onClick={() => {
                if (props.leftSidebarSlide) {
                  props.setLeftSidebarSlide(false);
                }
              }}
              to="/races"
            >
              <span className="icon">
                <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M31.8831 15.7543L25.7372 2.98851C25.4644 2.41992 24.7974 2.16038 24.2066 2.38406C23.3426 2.69311 22.6265 2.88094 21.9463 2.97485C20.0168 3.23917 17.9579 2.83176 16.1497 1.82913C13.8849 0.526661 11.3155 -0.0060733 8.71498 0.289321C6.44984 0.544419 4.34622 1.4084 2.5783 2.80034L2.25592 2.12896C2.23817 2.08866 2.21563 2.05281 2.18865 2.02173C2.23817 1.8964 2.2648 1.75741 2.2648 1.60989C2.2648 0.987681 1.75905 0.477485 1.1324 0.477485C0.510195 0.477485 0 0.983241 0 1.60989C0 2.1334 0.35823 2.57666 0.841447 2.70199C0.850326 2.72897 0.863986 2.76005 0.877304 2.78702L14.6188 31.3576C14.7485 31.6308 15.0217 31.7876 15.3038 31.7876C15.4155 31.7876 15.5275 31.765 15.6347 31.7114C16.0155 31.5277 16.1719 31.0756 15.993 30.6951L9.78011 17.7907C13.1954 14.9528 17.9893 14.5277 21.879 16.7703C23.2801 17.5714 24.8736 18.055 26.4847 18.1667C26.7265 18.1847 26.9639 18.1892 27.2056 18.1892C28.5795 18.1892 29.9629 17.9252 31.2339 17.4102C31.5474 17.2849 31.7933 17.0298 31.9142 16.7211C32.0395 16.4032 32.0262 16.0497 31.8831 15.7543ZM27.0308 16.6719L25.075 12.5627C25.1823 12.5671 25.2898 12.5671 25.3971 12.5671C26.4267 12.5671 27.4563 12.406 28.4364 12.0972L30.3699 16.1122C29.2823 16.5063 28.1543 16.6941 27.0308 16.6719ZM17.6714 13.8744L15.7153 9.7696C17.3313 9.90859 18.9336 10.3918 20.4065 11.2377C20.4375 11.2558 20.4645 11.2691 20.4959 11.2872L22.425 15.3288C20.9388 14.5143 19.3277 14.0219 17.6714 13.8744ZM8.85363 5.89771C10.3354 5.37864 11.9151 5.17272 13.4775 5.29361L15.5634 9.66681C13.9966 9.5548 12.4257 9.76516 10.9439 10.2846L8.85363 5.89771ZM15.3977 3.15413C15.3977 3.15413 15.4022 3.15413 15.4022 3.15857L15.4066 3.16301C15.9079 3.44065 16.427 3.67765 16.9553 3.87469L18.2936 6.68555C16.7985 5.82634 15.1737 5.34278 13.5355 5.20857L11.9554 1.89196C13.1418 2.10676 14.3056 2.52749 15.3977 3.15413ZM18.4995 6.89591C19.7484 7.56729 21.1495 7.97469 22.5685 8.06861C22.6579 8.07339 22.7518 8.07783 22.8413 8.08227L24.9316 12.4688C23.4232 12.3971 21.9282 11.9763 20.5629 11.2155L18.4995 6.89591ZM22.1474 4.48358C22.8727 4.38489 23.6203 4.19706 24.4884 3.89723L26.2433 7.54509C25.1509 7.8941 24.0229 8.04641 22.9042 8.00611L21.2612 4.56417C21.5611 4.55051 21.8564 4.52387 22.1474 4.48358ZM6.98257 2.17814L8.73274 5.8441C7.41252 6.31878 6.16811 7.03934 5.07122 7.99723L3.24968 4.20594C4.36876 3.27058 5.63981 2.58998 6.98257 2.17814ZM7.25577 12.5449C8.34344 11.587 9.58341 10.8709 10.8992 10.3962L12.815 14.4112C11.4722 14.8412 10.2189 15.5081 9.09985 16.381L7.25577 12.5449Z"
                    fill="white"
                  ></path>
                </svg>
              </span>
              <span className="text">{__("Races")}</span>
              <span className="arrow">{">"}</span>
            </Link>
          </li>
          {props.isAuthenticated && (
            <li className={"races " + (activeMenu === "/raffle-tickets" ? "active" : "")}>
              <Link
                className={activeMenu === "/raffle-tickets" ? "active" : ""}
                onClick={() => {
                  if (props.leftSidebarSlide) {
                    props.setLeftSidebarSlide(false);
                  }
                }}
                to="/raffle-tickets"
              >
                <span className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path
                      d="M3 6 h14 a2 2 0 0 1 2 2 v4 a2 2 0 0 1 -2 2 h-14 a2 2 0 0 1 -2 -2 v-4 a2 2 0 0 1 2 -2 z"
                      fill="white"
                    />
                    <path
                      d="M2 5 h16 a2 2 0 0 1 2 2 v4 a2 2 0 0 1 -2 2 h-16 a2 2 0 0 1 -2 -2 v-4 a2 2 0 0 1 2 -2 z"
                      fill="white"
                    />
                    <path
                      d="M4 7 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z M4 9 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z M4 11 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z M16 7 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z M16 9 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z M16 11 a0.5 0.5 0 1 0 0 1 a0.5 0.5 0 1 0 0 -1 z"
                      fill="black"
                    />
                    <path d="M6 9 h8" stroke="white" stroke-width="1" />
                  </svg>
                </span>
                <span className="text">{__("Raffle Tickets")}</span>
                <span className="arrow">{">"}</span>
              </Link>
            </li>
          )}
          {props.isAuthenticated && (
            <>
              <li className={"rewards " + (activeMenu === "/rewards" ? "active" : "")}>
                <Link
                  className={activeMenu === "/rewards" ? "active" : ""}
                  onClick={() => {
                    if (props.leftSidebarSlide) {
                      props.setLeftSidebarSlide(false);
                    }
                  }}
                  to="/rewards"
                >
                  <span className="icon">
                    <img alt="" src={require("../assets/images/v2/icons/rewards-icon.svg").default} />
                  </span>
                  <span className="text">{__("Rewards")}</span>
                  <span className="arrow">{">"}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/free-spins"
                  className={activeMenu === "free-spins" ? "active small_circle" : " small_circle"}
                  onClick={() => {
                    props.setShowLeftSidebar(false);
                  }}
                >
                  <span className="icon">
                    <svg width="22" height="23" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.23301 18.2619L8.32701 18.6849L7.90001 17.7779L8.80701 17.3559C9.04743 17.2437 9.23344 17.0406 9.32411 16.7913C9.41478 16.542 9.4027 16.2669 9.29051 16.0264C9.17832 15.786 8.97523 15.6 8.7259 15.5093C8.47657 15.4187 8.20143 15.4307 7.96101 15.5429L6.14801 16.3889C5.90775 16.5011 5.72189 16.7042 5.63131 16.9534C5.54074 17.2026 5.55286 17.4776 5.66501 17.7179L8.20101 23.1549C8.30693 23.3713 8.48613 23.5431 8.70676 23.6397C8.92739 23.7364 9.17516 23.7517 9.40601 23.6829C9.54155 23.6403 9.66645 23.5693 9.77239 23.4746C9.87833 23.38 9.96288 23.2638 10.0204 23.1339C10.0779 23.004 10.1071 22.8633 10.106 22.7212C10.1049 22.5791 10.0735 22.4389 10.014 22.3099L9.16801 20.4969L10.075 20.0739C10.3112 19.9592 10.4928 19.7562 10.5806 19.5088C10.6684 19.2613 10.6553 18.9893 10.5442 18.7514C10.4332 18.5135 10.233 18.3288 9.98689 18.2372C9.74081 18.1456 9.46859 18.1545 9.22901 18.2619H9.23301Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.086 17.41L16.881 18.497C17.0633 18.6134 17.2033 18.7854 17.2804 18.9875C17.3575 19.1897 17.3677 19.4112 17.3093 19.6195C17.2509 19.8278 17.1271 20.0118 16.9562 20.1444C16.7853 20.277 16.5763 20.3512 16.36 20.356C16.1772 20.3559 15.9979 20.3054 15.842 20.21L14.043 19.11L14.549 20.201C14.6069 20.3283 14.6376 20.4663 14.6393 20.6061C14.641 20.746 14.6135 20.8847 14.5587 21.0133C14.5038 21.142 14.4228 21.2578 14.3208 21.3535C14.2188 21.4492 14.0979 21.5225 13.966 21.569C13.7325 21.6447 13.4795 21.6336 13.2535 21.5377C13.0275 21.4418 12.8438 21.2675 12.736 21.047L10.2 15.61C10.1444 15.4909 10.1127 15.362 10.1069 15.2307C10.1011 15.0993 10.1213 14.9681 10.1662 14.8446C10.2112 14.7211 10.2801 14.6076 10.3689 14.5107C10.4578 14.4139 10.5648 14.3354 10.684 14.28L12.045 13.647C12.5494 13.4112 13.1183 13.3512 13.6608 13.4765C14.2034 13.6018 14.6883 13.9052 15.0383 14.3383C15.3883 14.7713 15.5831 15.3091 15.5918 15.8659C15.6004 16.4226 15.4224 16.9662 15.086 17.41ZM13.5017 15.6131C13.4436 15.5336 13.3634 15.473 13.271 15.439C13.2098 15.4161 13.1447 15.4057 13.0795 15.4083C13.0143 15.4108 12.9502 15.4264 12.891 15.454L12.436 15.666L12.858 16.572L13.312 16.36C13.401 16.3178 13.4755 16.2504 13.5263 16.166C13.5771 16.0817 13.6019 15.9842 13.5975 15.8858C13.5931 15.7875 13.5598 15.6926 13.5017 15.6131Z"
                        fill="white"
                      />
                      <path
                        d="M20.4709 16.3319L19.5639 16.7549L19.1409 15.8479L20.0479 15.4259C20.2888 15.3134 20.475 15.1099 20.5658 14.8601C20.6566 14.6103 20.6444 14.3347 20.5319 14.0939C20.4195 13.8531 20.216 13.6668 19.9662 13.576C19.7164 13.4852 19.4408 13.4974 19.1999 13.6099L18.2939 14.0329L17.8719 13.1259L18.7779 12.7039C19.0114 12.5876 19.1902 12.3848 19.2762 12.1386C19.3622 11.8925 19.3487 11.6224 19.2385 11.3861C19.1283 11.1497 18.9301 10.9658 18.6862 10.8735C18.4423 10.7812 18.172 10.7878 17.9329 10.8919L16.1199 11.7359C15.8797 11.8481 15.6938 12.0511 15.6032 12.3004C15.5127 12.5496 15.5248 12.8246 15.6369 13.0649L18.1739 18.5099C18.2861 18.7501 18.4892 18.936 18.7384 19.0266C18.9876 19.1172 19.2626 19.105 19.5029 18.9929L21.3159 18.1479C21.5568 18.0358 21.7432 17.8327 21.8342 17.5832C21.9253 17.3337 21.9135 17.0582 21.8014 16.8174C21.6894 16.5766 21.4863 16.3901 21.2367 16.2991C20.9872 16.208 20.7118 16.2198 20.4709 16.3319Z"
                        fill="white"
                      />
                      <path
                        d="M24.0939 14.642L24.9999 14.219C25.2395 14.1116 25.5117 14.1027 25.7578 14.1942C26.0039 14.2858 26.2041 14.4705 26.3152 14.7084C26.4262 14.9463 26.4393 15.2184 26.3515 15.4658C26.2637 15.7133 26.0821 15.9163 25.8459 16.031L24.0329 16.877C23.7927 16.9891 23.5177 17.0012 23.2684 16.9107C23.0192 16.8201 22.8162 16.6342 22.7039 16.394L20.1679 10.955C20.0558 10.7147 20.0437 10.4397 20.1342 10.1905C20.2248 9.94123 20.4107 9.73818 20.6509 9.62597L22.4639 8.78097C22.7044 8.66878 22.9795 8.6567 23.2288 8.74737C23.4782 8.83805 23.6813 9.02405 23.7934 9.26447C23.9056 9.50489 23.9177 9.78003 23.827 10.0294C23.7364 10.2787 23.5504 10.4818 23.3099 10.594L22.4029 11.016L22.8259 11.923L23.7319 11.5C23.851 11.4444 23.9798 11.4129 24.111 11.4071C24.2423 11.4013 24.3734 11.4215 24.4968 11.4664C24.6203 11.5113 24.7337 11.58 24.8306 11.6688C24.9274 11.7575 25.0059 11.8644 25.0614 11.9835C25.117 12.1025 25.1485 12.2313 25.1543 12.3626C25.1601 12.4938 25.1399 12.6249 25.095 12.7484C25.0501 12.8718 24.9814 12.9852 24.8926 13.0821C24.8039 13.179 24.697 13.2574 24.5779 13.313L23.6709 13.735L24.0939 14.642Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M29.711 12.693C29.1359 12.2668 28.6458 11.7366 28.266 11.13C28.0894 10.3994 28.0531 9.64203 28.159 8.89796L28.1592 8.89543C28.2441 7.50205 28.3404 5.92334 27.313 4.89796C26.285 3.87196 24.708 3.96596 23.313 4.05296C22.5685 4.15859 21.8108 4.12195 21.08 3.94496C20.4733 3.56514 19.9432 3.07502 19.517 2.49996L19.5151 2.49781C18.5766 1.42533 17.513 0.209961 16 0.209961C14.488 0.209961 13.4248 1.42374 12.4867 2.4947L12.483 2.49896C12.0568 3.07402 11.5267 3.56414 10.92 3.94396C10.1892 4.121 9.43138 4.15731 8.687 4.05096C7.296 3.96496 5.715 3.86896 4.687 4.89696C3.659 5.92496 3.756 7.50296 3.842 8.89696C3.94815 9.6414 3.91149 10.3992 3.734 11.13C3.35418 11.7366 2.86406 12.2668 2.289 12.693L2.28474 12.6967C1.21378 13.6348 0 14.698 0 16.21C0 17.722 1.21378 18.7851 2.28475 19.7232L2.289 19.727C2.86406 20.1531 3.35418 20.6833 3.734 21.29C3.91063 22.0208 3.94694 22.7786 3.841 23.523L3.84086 23.5252C3.7559 24.9177 3.65955 26.4965 4.687 27.523C5.715 28.55 7.287 28.455 8.687 28.368C9.43144 28.2618 10.1893 28.2985 10.92 28.476C11.5267 28.8558 12.0568 29.3459 12.483 29.921L12.4867 29.9252C13.4248 30.9962 14.488 32.21 16 32.21C17.512 32.21 18.5752 30.9962 19.5133 29.9252L19.517 29.921C19.9432 29.3459 20.4733 28.8558 21.08 28.476C21.8104 28.2988 22.568 28.2625 23.312 28.369C24.704 28.455 26.285 28.552 27.312 27.523C28.339 26.494 28.243 24.917 28.157 23.523C28.0509 22.7785 28.0875 22.0207 28.265 21.29C28.6448 20.6833 29.1349 20.1531 29.71 19.727L29.7122 19.7251C30.7846 18.7865 32 17.7229 32 16.21C32 14.698 30.7862 13.6348 29.7153 12.6967L29.711 12.693ZM28.394 18.222C27.5717 18.8313 26.8964 19.6172 26.418 20.522C26.1022 21.5308 26.0147 22.5972 26.162 23.644C26.222 24.615 26.29 25.717 25.899 26.107C25.51 26.4949 24.4174 26.4297 23.4502 26.3719L23.435 26.371C22.3886 26.2239 21.3226 26.311 20.314 26.626C19.4092 27.1044 18.6233 27.7796 18.014 28.602L18.0105 28.606C17.3176 29.3967 16.605 30.21 16 30.21C15.3948 30.21 14.6818 29.396 13.9906 28.607L13.988 28.604C13.3787 27.7816 12.5928 27.1064 11.688 26.628C11.0849 26.4028 10.4434 26.2985 9.8 26.321C9.40183 26.321 8.998 26.3455 8.59766 26.3698L8.56032 26.3721C7.58673 26.432 6.48778 26.4997 6.099 26.109C5.71 25.718 5.775 24.617 5.835 23.645C5.98256 22.5986 5.89545 21.5325 5.58 20.524C5.10156 19.6192 4.42633 18.8333 3.604 18.224L3.58609 18.2082C2.80369 17.5192 2 16.8114 2 16.21C2 15.6047 2.81392 14.8918 3.60298 14.2006L3.606 14.198C4.42833 13.5887 5.10356 12.8027 5.582 11.898C5.89781 10.8892 5.98525 9.82273 5.838 8.77596C5.778 7.80304 5.71004 6.70092 6.1 6.30996C6.487 5.92197 7.57507 5.98693 8.54153 6.04462L8.564 6.04596C9.61032 6.19504 10.6768 6.10791 11.685 5.79096C12.5898 5.31252 13.3757 4.63729 13.985 3.81496L14.0012 3.79657C14.6911 3.01333 15.3987 2.20996 16 2.20996C16.6052 2.20996 17.3182 3.02387 18.0093 3.81292L18.012 3.81596C18.6213 4.63829 19.4072 5.31352 20.312 5.79196C21.3208 6.10783 22.3872 6.19528 23.434 6.04796C24.406 5.98696 25.507 5.91896 25.897 6.31096C26.287 6.70296 26.221 7.80296 26.161 8.77496C26.0134 9.82133 26.1005 10.8874 26.416 11.896C26.8944 12.8007 27.5697 13.5867 28.392 14.196L28.396 14.1995C29.1868 14.8924 30 15.605 30 16.21C30 16.8152 29.1861 17.5281 28.397 18.2193L28.394 18.222Z"
                        fill="white"
                      />
                    </svg>
                  </span>

                  <span className="text">{__("Free Spins")}</span>
                  {freeSpinCount > 0 && <div className="notification_round orange"></div>}
                </Link>
              </li>
            </>
          )}
        </ul>

        <LanguageSwitcherAccordion {...props} />

        <div class="buy-crypto-block leftSideBlock">
          {!props.isAuthenticated && (
            <Link
              onClick={() => {
                props.setModalSignUpPropsData(true);
                setTimeout(function () {
                  props.setModalSignUpPropsData(false);
                }, 500);
              }}
              className="commonBtn filledBtn buyCryptoBtn"
            >
              <span className="icon">
                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                    fill="#47495F"
                  />
                </svg>
              </span>
              <span className="text">{__("Sign Up & Buy Crypto")}</span>
            </Link>
          )}

          {props.isAuthenticated && (
            <Link
              onClick={() => {
                props.setOpenWalletModalTab("buy_crypto");
              }}
              className="commonBtn filledBtn buyCryptoBtn"
            >
              <span className="icon">
                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                    fill="#47495F"
                  />
                </svg>
              </span>
              <span className="text">{__("Buy Crypto | Deposit")}</span>
            </Link>
          )}
          <div class="buy-crypto-block__methods">
            <div class="buy-crypto-block__method">
              <img src={require("assets/images/v2/icons/gpay.webp").default} alt="Google Pay" />
            </div>
            <div class="buy-crypto-block__method">
              <img src={require("assets/images/v2/icons/applepay.webp").default} alt="Apple Pay" />
            </div>
            <div class="buy-crypto-block__method">
              <img src={require("assets/images/v2/icons/mastercard.webp").default} alt="Mastercard" />
            </div>
            <div class="buy-crypto-block__method">
              <img src={require("assets/images/v2/icons/visa.webp").default} alt="Visa" />
            </div>
          </div>
        </div>
        <Link
          onClick={() => {
            if (props.leftSidebarSlide) {
              props.setLeftSidebarSlide(false);
            }
            handleChatToggle();
          }}
          className="commonBtn filledBtn liveSupportBtn"
        >
          <span className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18.292" height="18.292" viewBox="28 463.609 18.292 18.292">
              <g data-name="Icon ionic-ios-chatbubbles">
                <path
                  d="M44.841 475.595c0-.193.053-.378.145-.536.026-.049.062-.093.092-.137a7.125 7.125 0 0 0 1.214-3.97c.013-4.054-3.408-7.343-7.638-7.343-3.689 0-6.767 2.51-7.488 5.843a7.066 7.066 0 0 0-.163 1.504c0 4.059 3.29 7.436 7.52 7.436.672 0 1.578-.203 2.075-.339.497-.136.99-.317 1.117-.365a1.163 1.163 0 0 1 .853.013l2.493.884s.105.044.171.044a.35.35 0 0 0 .352-.352c0-.044-.022-.118-.022-.118l-.721-2.564Z"
                  fill="#b8c0da"
                  fill-rule="evenodd"
                  data-name="Path 9777"
                />
                <path
                  d="M39.894 478.757c-.158.044-.36.092-.58.14-.462.097-1.051.198-1.495.198-4.23 0-7.52-3.377-7.52-7.435 0-.29.031-.66.067-.941a6.03 6.03 0 0 1 .1-.563c.045-.198.097-.396.155-.59l-.352.313c-1.442 1.257-2.269 3.051-2.269 4.92a6.47 6.47 0 0 0 1.09 3.606c.102.154.159.272.141.352-.017.079-.523 2.726-.523 2.726a.353.353 0 0 0 .119.338c.066.053.145.08.224.08a.315.315 0 0 0 .127-.027l2.467-.972a.687.687 0 0 1 .25-.048s.106-.009.278.057a7.4 7.4 0 0 0 2.669.528c2.049 0 3.975-.884 5.28-2.423 0 0 .142-.193.304-.422a6.953 6.953 0 0 1-.532.163Z"
                  fill="#b8c0da"
                  fill-rule="evenodd"
                  data-name="Path 9778"
                />
              </g>
            </svg>
          </span>
          <span className="text">{__("Live Support")}</span>
        </Link>
        <div style={{ height: 200 }}></div>
      </div>
    </div>
  );
}
